/*
 * @Author: cryi.liu
 * @Date: 2020-06-04 10:26:43
 * @LastEditTime: 2020-06-04 10:39:24
 * @Description: pdfobject 插件包
 */
import pdfobject from 'pdfobject';

const Plugin = {
  install(Vue, name = '$pdf') {
    Object.defineProperty(Vue.prototype, name, { value: pdfobject });
  },
};

export default Plugin;
